import { defineMessages } from "react-intl";

const messages = defineMessages({
  discoverHeading: {
    id: "footer.discoverHeading",
    defaultMessage: "Discover",
    description: "Heading for the discover section",
  },
  transportationLink: {
    id: "footer.transportationLink",
    defaultMessage: "Transport",
    description: "Link that goes to home page",
  },
  hotelsLink: {
    id: "footer.hotelsLink",
    defaultMessage: "Hotels",
    description: "Link that goes to the hotels product page",
  },
  rentalCarsLink: {
    id: "footer.rentalCarsLink",
    defaultMessage: "Rental Cars",
    description: "Link that goes to rental cars",
  },
  getAppLink: {
    id: "footer.getAppLink",
    defaultMessage: "Get the App",
    description: "Link that goes to the app download page",
  },
  companyHeading: {
    id: "footer.companyHeading",
    defaultMessage: "Company",
    description: "Heading for the company section",
  },
  aboutUsLink: {
    id: "footer.aboutUsLink",
    defaultMessage: "About Us",
    description: "Link that goes to the about us page",
  },
  careersLink: {
    id: "footer.careersLink",
    defaultMessage: "Careers",
    description: "Link that goes to the careers page",
  },
  advertiseLink: {
    id: "footer.advertise",
    defaultMessage: "Advertise",
    description: "Link that goes to the advertise page",
  },
  mediaLink: {
    id: "footer.mediaLink",
    defaultMessage: "Media",
    description: "Link that goes media page",
  },
  helpLink: {
    id: "footer.helpLink",
    defaultMessage: "Help",
    description: "Link that goes to the help page",
  },
  supportHeading: {
    id: "footer.supportHeading",
    defaultMessage: "Support",
    description: "Heading for the support section",
  },
  contactUsLink: {
    id: "footer.contactUsLink",
    defaultMessage: "Contact Us",
    description: "Link that goes to the contact us page",
  },
  getListedLink: {
    id: "footer.getListedLink",
    defaultMessage: "Get Listed",
    description: "Link that goes to the get listed page",
  },
  companyDisclosureLink: {
    id: "footer.companyDisclosureLink",
    defaultMessage: "Company Disclosure",
    description: "Link that goes the company disclosure page",
  },
  termsLink: {
    id: "footer.termsLink",
    defaultMessage: "Terms",
    description: "Link that goes the terms page",
  },

  privacyPolicyLink: {
    id: "footer.privacyLink",
    defaultMessage: "Privacy Policy",
    description: "Link that goes to the privacy policy page",
  },
  photoCreditsLink: {
    id: "footer.photoCreditsLink",
    defaultMessage: "Photo Credits",
    description: "Link that goes to the photo credits legal page",
  },
  dataSourcesLink: {
    id: "footer.dataSourcesLink",
    defaultMessage: "Data Sources",
    description: "Link that goes to the data sources legal page",
  },
});

export default messages;
